import { message } from 'antd';
import { all, select, fork, cancel, race, call, put, take, takeEvery, takeLatest, cancelled } from 'redux-saga/effects';
import { push, replace } from 'redux-little-router';
import { API_URL } from '../../api/config';
import categoriesAPI from '../../api/categoriesAPI';

const fetchCategoryCollection = function* fetchCategoryCollection() {
  const connection = yield select(store => store.connection.byId[store.connection['/window'].ids[0]]);

  while (true) {
    yield put({ type: '__FETCH_CATEGORY_COLLECTION' });
    try {
      const response = yield call(categoriesAPI.getAllCategories, connection);
      yield put({ type: '__RECEIVE_CATEGORY_COLLECTION', payload: { collection: response } });
    } catch (e) {
      console.log(e);

      yield put({ type: '__ERROR_CATEGORY_COLLECTION', payload: { message: 'Error loading categories' } });
      message.error('Error loading categories');
    }

    yield take(action => (
      action.type === 'ROUTER_LOCATION_CHANGED' &&
      action.payload.pathname === '/tab/browse'
    ));
  }
};

const browseTabProcess = function* () {
  yield call(fetchCategoryCollection);
};

export default browseTabProcess;
